import styles from "./service_brand.module.scss"
import parse from "html-react-parser"
import { stripMarkup } from "shared/lib/strip_markup"

interface Props {
  description?: string
  descriptionHtml?: string
  image?: string
  title: string
}

export default function ServiceBrand({ description, descriptionHtml, image, title }: Props) {
  return (
    <>
      <img title={title} alt={title} className={styles["service-brand"]} width="128" height="128" src={image} />
      <div className={styles.txt}>
        <h1 className={`text-h2 ${styles["brand-title"]}`}>{parse(stripMarkup(title))}</h1>
        {/* The global class is the hook that retargets the HTML's links; plain text has none. */}
        {descriptionHtml && (
          <div className={`service-diy-description ${styles["brand-description"]}`}>{parse(descriptionHtml)}</div>
        )}
        {!descriptionHtml && description && <div className={styles["brand-description"]}>{description}</div>}
      </div>
    </>
  )
}
